import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/app/routes';
import { LoadingOverlay } from '@/components/feedback';
import { useTranslations } from '@/hooks';
import { useCreateContractMutation } from '../api/contractsApi';
import { ContractForm, EMPTY_CONTRACT_FORM } from '../components/ContractForm';
import { useContractFormOptions } from '../hooks';

// Inbounds ▸ Contracts ▸ Add.
export const AddContractPage = () => {
  const t = useTranslations();
  const navigate = useNavigate();
  const { module } = useParams();

  const { options, sites, materials, getEquivalentUnit, isLoading } = useContractFormOptions();
  const [createContract, { isLoading: isSubmitting }] = useCreateContractMutation();

  const goToContracts = useCallback(() => {
    navigate(ROUTES.contracts(module));
  }, [navigate, module]);

  const handleSubmit = useCallback(
    async (values) => {
      const result = await createContract({
        module,
        values,
        equivalentUnit: getEquivalentUnit(values),
      });
      if (result.error) return;
      goToContracts();
    },
    [createContract, module, getEquivalentUnit, goToContracts],
  );

  // Wait for the dropdowns: <Form> seeds initialValues once, on mount.
  if (isLoading) {
    return <LoadingOverlay label={t('COMMON_LOADING')} />;
  }

  return (
    <ContractForm
      title={t('CONTRACTS_ADD_TITLE')}
      submitLabel={t('COMMON_SAVE')}
      initialValues={EMPTY_CONTRACT_FORM}
      options={options}
      sites={sites}
      materials={materials}
      onSubmit={handleSubmit}
      onClose={goToContracts}
      isSubmitting={isSubmitting}
    />
  );
};
